import { Languages } from '../app/shared/enums/languages.enum';
import { MobileWebAppPopupMode } from '../app/shared/enums/mobile-web-app-popup-mode.enum';
import { AppVersions } from '../app/shared/enums/quick-links-for.enum';
import { Environment } from './contract/environment.contract';

export const environment: Environment = {
  production: true,
  enableServiceWorker: true,

  matomo: {
    url: 'https://analyze.onestop-pro.de/',
    siteId: 13
  },

  firebase: {
    apiKey: 'AIzaSyDrpKgUrkns8VAo0ylVmxJsrvKpobRnzEE',
    authDomain: 'onestoppro-prod.firebaseapp.com',
    databaseURL: 'https://onestoppro-prod.firebaseio.com',
    projectId: 'onestoppro-prod',
    storageBucket: 'onestoppro-prod.appspot.com',
    messagingSenderId: '1013910056477',
    appId: '1:1013910056477:web:7c8cb4c1b2c343ff'
  },

  keycloak: {
    initOptions: {
      onLoad: 'check-sso',
    }
  },

  PAGE_TITLE: 'EquipCare',
  PAGE_FAVICON: '/assets/icons/ec-favicon.png',

  APP_DOMAIN: 'app.onestop-pro.de',
  APP_REALM: 'wackerneuson',
  APP_CLIENT_ID: 'frontend-eqc',
  APP_KEYCLOAK_BASE_URL: 'https://sso.equipcarepro.wackerneuson.com',

  APP_WACKER_NEUSON_CLIENT_ID: 'frontend-revolution',
  APP_WACKER_NEUSON_DOMAIN: 'equipcarepro.wackerneuson.com',
  APP_WACKER_NEUSON_REALM: 'wackerneuson',
  APP_WACKER_NEUSON_KEYCLOAK_BASE_URL: 'https://sso.equipcarepro.wackerneuson.com',
  APP_WACKER_NEUSON_LOGOUT_REDIRECT_URL: 'https://mylogin.wackerneusongroup.com/login/oidc/logout.html',

  APP_TRIATHLON_CLIENT_ID: 'frontend-revolution',
  APP_TRIATHLON_DOMAIN: 'app.trivent.cloud',
  APP_TRIATHLON_REALM: 'triathlon',
  APP_TRIATHLON_KEYCLOAK_BASE_URL: 'https://sso.trivent.cloud',

  APP_EQUIPMENT_SERVICE_BASE_URL: 'https://app.onestop-pro.de/equipment-api',
  APP_TELEMATICS_SERVICE_BASE_URL: 'https://app.onestop-pro.de/telematics-api',
  APP_DISPOSITION_SERVICE_BASE_URL: 'https://app.onestop-pro.de/disposition-api',
  APP_JOB_SERVICE_BASE_URL: 'https://app.onestop-pro.de/job-api',
  APP_USERROLE_SERVICE_BASE_URL: 'https://app.onestop-pro.de/userrole-api',
  APP_ORGANISATION_SERVICE_BASE_URL: 'https://app.onestop-pro.de/organisation-api',
  APP_NOTIFICATION_SERVICE_BASE_URL: 'https://app.onestop-pro.de/notifications-api',
  APP_COMMUNICATION_SERVICE_BASE_URL: 'https://app.onestop-pro.de/communication-api',
  APP_REPORT_SERVICE_BASE_URL: 'https://app.onestop-pro.de/report-api',
  APP_EQUIPMENT_AUDIT_SERVICE_BASE_URL: 'https://app.onestop-pro.de/equipment-audit-api',
  APP_PUSH_SERVICE_BASE_URL: 'https://app.onestop-pro.de/push-api',
  APP_MAINTENANCE_SERVICE_BASE_URL: 'https://app.onestop-pro.de/maintenance-api',
  APP_CORE_DATA_SERVICE_BASE_URL: 'https://app.onestop-pro.de/core-data-api',
  APP_TRANSPORT_SERVICE_BASE_URL: 'https://app.onestop-pro.de/transport-api',
  APP_FILE_SERVICE_BASE_URL: 'https://api.onestop-pro.de/file-api',
  APP_FILE_DOWNLOAD_SERVICE_BASE_URL: 'https://files.onestop-pro.de',
  logErrorsInSentry: true,
  SENTRY: 'https://bedcefcae01982ca2907df570e10f624@o1221674.ingest.us.sentry.io/4509332132593664',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAMc_S3v3uuCWzXLm3BQgC4kTy4T4ziv2A',
  DS_SCANNER_LICENCE_KEY: 'ER0QaFYvpfob1/JVLOLf7QhmhSgBywMMtI0MJiS327GMWOqIatsNo1Reen2ee/CM5/1OC2yNX7UlWsRbNDpb/HgHOkj/1Qlv+EGPMYUgI2BMlAKnN35TTsr/Co7j+nf8fSBttr2XdbPMwZPOu4IlVjQ5n7ZGpN057CcZGG6IURKSrcgXIltFaIY6giQ4WmueC1ScO8LURfib0qsvUwRr7x2CINuiRV86OfIOKRkhO1DWRsnuJUD15ryGQ73WfmhW2UXxeoY8McVPac7E9el+QjG2BH1fSNpc4ygTbpXa0ateIMGZKFu30I9pS/hPjyJ2JrMJcOAjedlWNgGLDO9uFA==',
  DELAY_SHORTEST: 500,
  DELAY_SHORT: 1000,
  DELAY_LONG: 2000,
  DELAY_LONGEST: 4000,
  MOBILE_WEB_APP_POPUP_MODE: MobileWebAppPopupMode.SHOW_POPUP_NOT_CLOSABLE,

  DIGITS_PRECISION_DEFAULT: 3,
  DIGITS_PRECISION_MILEAGE: 3,
  DIGITS_PRECISION_OPERATING_HOURS: 3,

  FALLBACK_LANGUAGE: Languages.EN,

  FOTA_API_TOKEN: '3026|oIdxHkfR93MbCBkKIV5o5MkjImSNpo279CRd39Av',

  APP_TRANSLATION_BASE_URL: 'https://localization.infrastructure.onestoppro.de/osp-infrastructure-localization-api/frontend-revolution',
  APP_TRANSLATION_API_KEY: 'KRIcGPZWpp3fvBIF1mcmD5gYMiZPJIua1ABScofj',

  EQUIPMENT_SEARCH_V2_TOGGLE_AVAILABLE: false,
  EQUIPMENT_EVENTS_TOGGLE_AVAILABLE: false,

  APP_VERSION: AppVersions.WN,
  DEBUG: false,

  ACCOUNT_MANAGER_URL: 'https://account.wackerneusongroup.com/',
  FLEET_OVERVIEW_URL: 'https://account.wackerneusongroup.com/assets',
  EXTERNAL_SETTINGS_URL: 'https://account.wackerneusongroup.com/profile',
  CAN_EDIT_USER_SETTINGS: false,
  CAN_EDIT_TIMEZONE_SETTINGS: true,

  STANDALONE_SHIFT_AVAILABLE: true,

  EXTERNAL_LEGAL_URL: 'https://account.wackerneusongroup.com/legal',
};
